// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"cad63971","742":"162ff6c1"}[chunkId] + ".chunk.css";
};